import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-header-section',
  templateUrl: './split-header-section.component.html',
  styleUrls: ['./split-header-section.component.scss']
})
export class SplitHeaderSectionComponent {
  @Input() public title!: string;
}
